<template>
    <div class="container">
        <div style="display: flex; align-items: center; position: relative;">
            <MercenaryHeader style="flex: 1;" :title="mode === FORM_MODE.UPDATE ? '입단 요청서 수정' : '기본 정보 작성'" :back-title="'뒤로가기'" :close-action="beforeClose" />
            <div @click="showConfirmPopup(1)" style="position: absolute; right: 22px; top: 50%; transform: translateY(-50%);">
                <img style="width: 12px;" :src="require('@/assets/img/x_btn_gray.png')" alt="">
            </div>
        </div>
        <div class="status_bar_container">
            <div v-if="mode === FORM_MODE.INSERT && step < 6" class="status_bar_content">
                <div class="status_bar_content_title">꿈을 향한 첫 걸음! 시작해볼까요? 🚀</div>
                <div class="status_bar_step">{{ step }}/<span style="font-size: 12px; color: #808080;">5</span></div>
            </div>
            <div v-if="mode === FORM_MODE.INSERT && step < 6" class="status_bar_progress">
                <div :style="{ width: step * 16 + '%' }" style="transition: width 0.3s;" class="status_bar_progress_bar"></div>
            </div>
            <template v-if="step === 1 || step === 2">
                <div class="main_title">기본 정보 작성</div>
            </template>
            <template v-if="step === 3">
                <div class="main_title">어디서 뛰고 싶으신가요?</div>
                <div class="step_three_description">희망하는 지역을 선택해주세요. <span>중복 선택</span>도 가능합니다.</div>
            </template>
            <template v-if="step === 4 || step === 5">
                <div class="main_title">나의 실력</div>
            </template>
        </div>
        <div class="content_container">
            <template v-if="step === 1">
                <div class="form_wrapper">
                    <div class="label">이름(실명)</div>
                    <input v-model="name"  placeholder="홍길동" class="common_input" type="text">
                </div>
                <div class="form_wrapper">
                    <div class="label">생년월일</div>
                    <div @click="showCalendar" class="select_box">
                        <div v-if="birthday === ''" style="font-size: 14px; font-weight: 500; color: #bdbdbd;" class="select_box_text">2008.05.20</div>
                        <div v-else style="font-size: 14px; font-weight: 500;" class="select_box_text active">{{ birthday }}</div>
                    </div>
                </div>
                <template v-if="playerType === TYPE.ELITE || playerTypeCopy === TYPE.ELITE">
                    <div class="form_wrapper">
                        <div class="label">현재/이전 소속팀</div>
                        <input v-model="team" placeholder="예) 사커하우 U12" class="common_input" type="text">
                        <div class="description">소속팀 정보는 관리자 확인용이며 외부에 공개되지 않습니다.</div>
                    </div>
                    <div v-if="playerProofFiles.length === 0" @click="showPlayerProofFiles" class="image_container">
                        <div>
                            <img style="width: 24px;" :src="require('@/assets/img/img_icon.png')" alt="">
                        </div>
                        <div class="image_container_text">선수임을 증명할 수 있는 사진 또는 JoinKFA 등록 사진 제출 (필수)</div>
                    </div>
                    <div v-else class="upload_image_container hide_scroll">
                        <div v-for="each, i in playerProofFiles" :key="each.id">
                            <div v-if="each" style="position: relative; width: 112px; height: 150px; margin-right: 10px; ">
                                <img style="border-radius: 12px; object-fit: cover; width: 100%; height: 100%;" :src="each.src" alt="" />
                                <div @click="deletePlayerProofFiles(i)" style="position: absolute; right: 6px; bottom: 6px;">
                                    <img style="width: 32px;" :src="require('@/assets/img/delete_img.png')" alt="">
                                </div>
                            </div>
                        </div>
                        <div v-if="playerProofFiles.length < 5" @click="showPlayerProofFiles" class="upload_image_box">
                            <div>
                                <img style="width: 24px;" :src="require('@/assets/img/img_icon.png')" alt="">
                            </div>
                        </div>
                    </div>
                    <div style="display:flex; align-items: center;">
                    </div>
                </template>
            </template>
            <template v-if="step === 2">
                <div class="select_container">
                    <div @click="selectItem(item)" v-for="item in stepTwoArr" :key="item.label" class="select_wrapper">
                        <div class="label">{{ item.label }}</div>
                        <div v-if="item.label !== STEP_TWO_LABEL.HEIGHT && item.label !== STEP_TWO_LABEL.WEIGHT" class="select_box">
                            <div v-if="!item.value" class="select_box_text">{{ item.placeholder }}</div>
                            <div v-else class="select_box_text active">{{ item.value }}</div>
                        </div>
                        <input v-else v-model="item.value" class="common_input" type="tel" :placeholder="item.placeholder" />
                    </div>
                </div>
            </template>
            <template v-if="step === 3">
                <div @click="selectRegion('전국')" :class="{ 'active_region': selectedRegion.includes('전국') }" class="common_region_box all_region">
                    <img style="width: 18px;" :src="require('@/assets/img/all_region.png')" alt="">
                    <div class="all_region_text">전국 (지역 상관없음)</div>
                </div>
                <div class="region_list_title">주요 지역</div>
                <div  class="region_list_container">
                    <div :class="{ 'active_region': selectedRegion.includes(each.region_name) }" class="common_region_box" @click="selectRegion(each.region_name)" v-for="each, i in regionList" :key="i + 'region_list'">{{ each.region_name }}</div>
                </div>
                <div @click="resetRegion" class="region_reset_btn">지역 초기화</div>
            </template>
            <template v-if="step === 4">
                <div class="skill_container">
                    <div class="introduce_container">
                        <div class="introduce_title_wrapper">
                            <div class="skill_title">한 줄 소개</div>
                            <div class="introduce_count"><span>{{ introduceCount }}</span>/{{ introduceMaxLen }}</div>
                        </div>
                        <input
                            :value="isIntroduceComposing ? introduceComposingValue : introduceText"
                            @input="onIntroduceInput"
                            @compositionstart="onIntroduceCompositionStart"
                            @compositionupdate="onIntroduceCompositionUpdate"
                            @compositionend="onIntroduceCompositionEnd"
                            :maxlength="introduceMaxLen"
                            placeholder="예: 패스를 잘하는 중앙 미드필더입니다."
                            class="skill_common_input"
                            type="text"
                        >
                    </div>
                    <div class="request_container">
                        <div class="skill_title">입단 요청서</div>
                        <textarea v-model="requestText" placeholder="본인의 프로필과 강점을 소개하고 축구팀 입단을 하기 위해 하고 싶은 말들을 자유롭게 입력하세요" class="skill_common_input textarea" type="text"></textarea>
                    </div>
                </div>
            </template>
            <template v-if="step === 5">
                <div style="margin-top: 20px;">
                    <div style="font-weight: 700; font-size: 12px; line-height: 20px;">사진이나 영상을 같이 넣으면 더 많은 팀에서 제안이 들어올 수 있어요🚀</div>
                    <div style="font-weight: 700; font-size: 12px; line-height: 20px; color: #808080;">최소 한 장의 미디어를 추가해주세요</div>
                    <div style="display: flex; margin: 0 -24px; padding: 0 24px; gap: 12px; margin-top: 8px; overflow-x: scroll;" class="hide_scroll">
                        <div v-for="each, i in 3" :key="i">
                            <div v-if="!imgSrcArr[i]" @click="showFiles(i)" style="width: 200px; height: 200px; background-color: #210F034D; gap: 8px; flex-direction: column; border-radius: 12px; flex-shrink: 0; display: flex; justify-content: center; align-items: center;">
                                <img style="width: 32px;" :src="require('@/assets/img/request_form_img.png')" alt="">
                                <div style="font-size: 12px; line-height: 24px; font-weight: 700; color: #fff;" v-if="i === 0">[필수] 미디어 추가</div>
                                <div v-else style="font-size: 12px; line-height: 24px; font-weight: 700; color: #fff;">미디어 추가</div>
                            </div>
                            <div style="position: relative;" v-else-if="imgSrcArr[i] && !imgSrcArr[i].isVideo">
                                <img style="width: 200px; height: 200px; border-radius: 12px; object-fit: cover;" :src="imgSrcArr[i].src" alt="">
                                <div @click="deleteImg(i)" style="position: absolute; right: 12px; bottom: 12px;">
                                    <img style="width: 32px;" :src="require('@/assets/img/delete_img.png')" alt="">
                                </div>
                            </div>
                            <div style="position: relative;" v-else-if="imgSrcArr[i] && imgSrcArr[i].isVideo">
                                <video preload="none" width="200" height="200" style="border-radius: 12px;" autoplay="false">
                                    <source :src="imgSrcArr[i].src + $Util.getStrForVideoPreview()" type="video/mp4">
                                </video>
                                <div @click="deleteImg(i)" style="position: absolute; right: 12px; bottom: 12px;">
                                    <img style="width: 32px;" :src="require('@/assets/img/delete_img.png')" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top: 10px; margin-bottom: 30px;">
                    <div style="font-weight: 700; font-size: 12px; line-height: 20px;">플레이 영상이 유튜브에 있다면 링크를 첨부해주세요</div>
                    <div style="position:relative; margin-top: 8px;">
                        <img :src="require('@/assets/img/soccerhow_write_link_url.png')" style="position:absolute; left:12px; top: 50%; transform: translateY(-50%); width:20px; height:18px;">
                        <input style="border:0px; height: 56px; border-radius: 12px; outline:none; width:100%; background-color: #210F030D; font-size:16px;color:black; padding: 10px 0px; padding-left:37px;" placeholder="유튜브 URL" @blur="detectLink" @click.stop ref="linkRef" v-model="youtubeLink" />
                    </div>
                    <div v-if="isShowYoutubeFrame" style="border-radius:12px;overflow:hidden; margin-top: 8px;">
                        <ContentsViewer :contents="youtubeLink" style="" />
                    </div>
                </div>
            </template>
            <template v-if="step === 6">
                <div style="text-align: center; margin-top: 40px;">
                    <div style="font-size: 32px; font-weight: 700; line-height: 40px;">완벽합니다!</div>
                    <div style="font-size: 24px; font-weight: 700; line-height: 40px;">일반 입단 요청서가 완성되었어요.</div>
                    <div style="font-weight: 500; line-height: 24px;">이적시장에는 이렇게 노출이 됩니다.</div>
                </div>
                <div style="margin-top: 17px; border-radius: 24px; box-shadow: 0px 0px 20px 0px #00000026; background: #FFFFFF1A; padding: 20px 12px;">
                    <div class="header_section">
                        <div class="profile_section">
                            <ProfileImage :image-path="$GlobalStore.loginInfo().image_path" style="width: 40px;"></ProfileImage>
                            <div class="profile_info">
                                <div class="name_row">
                                    <div class="player_name">
                                        {{ name }}
                                        <span>
                                            <img style="width: 13px;" :src="require('@/assets/img/verified_parent.png')" alt="">
                                        </span>
                                    </div>
                                </div>
                                <div class="location">{{ $GlobalStore.loginInfo().place_name }}</div>
                            </div>
                            <div class="age_badge">
                                <div style="line-height: 16px;">{{ stepTwoArr[5].value }}</div>
                                <div style="line-height: 16px; font-size: 12px; color: var(--color-main); font-weight: 700;">{{ playerType === TYPE.ELITE || playerTypeCopy === TYPE.ELITE ? '엘리트 선수' : '비선출 선수' }}</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="stats_section">
                            <div class="stat_item">
                                <div class="stat_label">포지션</div>
                                <div class="stat_value">{{ stepTwoArr[4].value }}</div>
                            </div>
                            <div class="stat_divider"></div>
                            <div class="stat_item">
                                <div class="stat_label">신장</div>
                                <div class="stat_value">{{ stepTwoArr[2].value }}cm</div>
                            </div>
                            <div class="stat_divider"></div>
                            <div class="stat_item">
                                <div class="stat_label">체중</div>
                                <div class="stat_value">{{ stepTwoArr[3].value }}kg</div>
                            </div>
                            <div class="stat_divider"></div>
                            <div class="stat_item">
                                <div class="stat_label">주발</div>
                                <div class="stat_value">{{ stepTwoArr[1].value }}</div>
                            </div>
                        </div>
                        <div class="region_section">
                            <div style="background-color: #FF71111A;" class="region_common_wrapper">
                                <div>
                                    <img style="width: 12px;" :src="require('@/assets/img/region_icon.png')" alt="">
                                </div>
                                <div style="font-weight: 700;">희망 지역</div>
                            </div>
                            <div style="background-color: #210F031A" class="region_common_wrapper" v-for="each, i in selectedRegion" :key="i + 'region_list'">
                                <div>
                                    {{ each }}
                                </div>
                            </div>
                        </div>
                        <div class="intro_section">
                            <div class="quote">{{ introduceText }}</div>
                            <div class="intro_text_wrapper">
                                <div class="intro_text ellipsis">{{ $Util.removeYoutubeLink(requestText) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div style="display:flex; align-items: center;">
            <!-- 사진 여러장 업로드 할 시 input태그 추가 -->
            <input type="file" style="display:none;" ref="file0" data-id="file0" @change="readURL($event)">
            <input type="file" style="display:none;" ref="file1" data-id="file1" @change="readURL($event)">
            <input type="file" style="display:none;" ref="file2" data-id="file2" @change="readURL($event)">
        </div>
        <div class="footer_container">
            <div v-if="step === 1" class="footer_description">
                <div class="exclamation_mark">!</div>
                <div class="footer_description_text">허위 사실 기재 시 입단 요청서 삭제 및 앱 서비스 이용 제한이 있을 수 있습니다.</div>
            </div>
            <div v-if="step === 4">
                <div class="request_description">요청서를 길고 구체적으로 작성할수록<br>감독님들의 관심을 받을 확률이 커집니다</div>
            </div>
            <div v-if="step === 6">
                <div style="font-weight: 600; font-size: 12px; line-height: 24px; text-align: center;">사커하우가 선수님의 빛나는 꿈을 진심으로 응원합니다! ⚽✨</div>
            </div>
            <div v-if="step === 1" @click="nextStep" class="footer_btn" :class="{ 'active': activeBtnStepOne }">다음</div>
            <div v-if="step === 2" @click="nextStep" class="footer_btn" :class="{ 'active': activeBtnStepTwo }">다음</div>
            <div v-if="step === 3" @click="nextStep" class="footer_btn" :class="{ 'active': activeBtnStepThree }">다음</div>
            <div v-if="step === 4" @click="nextStep" class="footer_btn" :class="{ 'active': activeBtnStepFour }">다음</div>
            <div v-if="step === 5 && mode === FORM_MODE.INSERT" @click="nextStep" class="footer_btn" :class="{ 'active': activeBtnStepFive }">다음</div>
            <div v-if="step === 5 && mode === FORM_MODE.UPDATE" @click="showConfirmPopup(2)" class="footer_btn" :class="{ 'active': activeBtnStepFive }">수정하기</div>
            <div @click="uploadSoccerHow" v-if="step === 6" class="footer_btn active">일반 입단 요청서 업로드</div>
        </div>
        <CommonPopupFrame :changeHeight="'auto'" :isOpen="isOpenCommonPopupFrame" :closeCompleteAction="closeCommonPopupFrame" :changeBottom="0">
            <div style="">
                <div class="common_popup_header"></div>
            </div>
            <div class="common_popup_content">
                <div class="title">{{ popupTitle }}</div>
                <div @touchmove.stop="() => { }" class="select_list_wrapper">
                    <div @click="selectItemList(each)" class="select_list_item" :style="{ borderBottom: i === selectList.length - 1 ? 'none' : '1px solid #210F0317' }" v-for="each, i in selectList" :key="i + 'select_list_item'">
                        {{ each.label }}
                    </div>
                </div>
            </div>
        </CommonPopupFrame>
        <DateSelectorPopupVer2 :is-show-date-selector="isShowDateSelector" :hide="() => { isShowDateSelector = false; }" :complete-action="setBirthDate"></DateSelectorPopupVer2>
        <MakeRequestJoinForm :passStep="3" :preparedFormData="preparedFormData" :isShowMakeRequestJoinForm="isShowMakeRequestJoinForm" :closeRequestJoinForm="closeRequestJoinForm"></MakeRequestJoinForm>
        <CommonConfirmFrame v-if="isShowConfirmPopup" :isShowConfirmPopup="isShowConfirmPopup" :closeConfirmPopup="closeConfirmPopup">
            <div class="confirm_draft_content">
                <div @click="closeConfirmPopup" class="confirm_close_btn">
                    <img style="width: 14px;" :src="require('@/assets/img/x_btn_gray.png')" alt="">
                </div>
                <div class="confirm_icon_wrapper">
                    <img style="width: 17px;" :src="require('@/assets/img/writing_request.png')" alt="">
                </div>
                <div class="confirm_title">입단 요청서 작성을 그만두시겠어요?</div>
                <div class="confirm_desc">
                    지금까지 작성한 소중한 정보가 사라지지 않도록<br>"임시 저장"해 드릴까요?
                </div>
                <div class="confirm_btn_row">
                    <div @click="deleteDraft" class="confirm_btn_new">그냥 나가기</div>
                    <div @click="saveSoccerHowDraft" class="confirm_btn_continue">네, 저장하고 나갈게요</div>
                </div>
            </div>
        </CommonConfirmFrame>
        <CommonConfirmFrame v-if="isShowUpdateConfirmPopup" :isShowConfirmPopup="isShowUpdateConfirmPopup" :closeConfirmPopup="closeUpdateConfirmPopup">
            <div v-if="updateStep === 1" class="confirm_draft_content" style="padding-top: 10px;">
                <div class="confirm_title">정말로 나가시겠어요?</div>
                <div class="confirm_desc">
                    지금 나가시면 작성 중이던<br>수정 내용이 모두 사라집니다.
                </div>
                <div class="confirm_btn_row">
                    <div @click="() => { $GlobalStore.closeLastModal(); }" class="confirm_btn_new">나가기</div>
                    <div @click="closeUpdateConfirmPopup" class="confirm_btn_continue">계속 수정하기</div>
                </div>
            </div>
            <div v-if="updateStep === 2" class="confirm_draft_content" style="padding-top: 10px;">
                <div class="confirm_title">수정을 완료하시겠습니까?</div>
                <div class="confirm_desc">
                    입단 요청서 내용이 새롭게 업데이트 됩니다.<br>이대로 요청서를 저장할까요?
                </div>
                <div class="confirm_btn_row">
                    <div @click="closeUpdateConfirmPopup" class="confirm_btn_new">조금 더 보기</div>
                    <div @click="updateSoccerHow" class="confirm_btn_continue">수정 완료하기</div>
                </div>
            </div>
        </CommonConfirmFrame>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import CommonConfirmFrame from '@/components/common/CommonConfirmFrame'
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ProfileImage from '@/components/common/ProfileImage'
import ContentsViewer from '@/components/common/ContentsViewer'
import { TYPE } from '@/components/soccerhowmain/SelectPlayerType'
import DateSelectorPopupVer2 from '@/components/common/DateSelectorPopupVer2'
import MakeRequestJoinForm from '@/components/soccerhowmain/MakeRequestJoinForm'
import { SOCCER_HOW_TYPE, PROFILE_FOOT_WAY } from '@/Constants'
import { FORM_MODE } from '@/Constants'

const STEP_TWO_LABEL = {
    GRADE: '학년',
    FOOT_WAY: '주발',
    HEIGHT: '키 (cm)',
    WEIGHT: '몸무게 (kg)',
    POSITION: '주 포지션',
    PREFERRED_AGE_TEAM: '희망 연령팀',
}

export default {
    name: 'WriteDefaultInfoForm',
    props: {
        playerType: {
            type: String,
            default: TYPE.CHALLENGE
        },
        soccerhowDraft: {
            type: Object,
            default: () => { }
        },
        isDraft: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String,
            default: FORM_MODE.INSERT
        },
        soccerhowIdx: {
            type: [Number, String],
            default: -1
        },
        completeAction: {
            type: Function,
            default: () => { }
        },
        completeModifyAction: {
            type: Function,
            default: () => { }
        }
    },
    created() {
        if (this.mode === FORM_MODE.INSERT) {
            this.stepTwoArr[1].value = this.transFootWay(this.$GlobalStore.loginInfo().foot_way)
            this.stepTwoArr[2].value = this.$GlobalStore.loginInfo().height ? this.$GlobalStore.loginInfo().height : ''
        }

        if (this.isDraft) {
            this.setDraftInfo()
        }

        if (this.mode === FORM_MODE.UPDATE) {
            this.getSoccerhowInfo()
        }
    },
    computed: {
        introduceCount() {
            const current = this.isIntroduceComposing ? this.introduceComposingValue : this.introduceText
            const len = (current || '').length
            return Math.min(len, this.introduceMaxLen)
        },
        activeBtnStepOne() {
            if (this.playerType === TYPE.ELITE || this.playerTypeCopy === TYPE.ELITE) {
                return this.name && this.birthday && this.team;
            } else {
                return this.name && this.birthday;
            }
        },
        activeBtnStepTwo() {
            return this.stepTwoArr.every(each => each.value !== '');
        },
        activeBtnStepThree() {
            return this.selectedRegion.length > 0;
        },
        activeBtnStepFour() {
            return this.introduceText ? this.introduceText.length > 0 && this.requestText.length > 0 : false;
        },
        activeBtnStepFive() {
            return this.imgSrcArr.some(each => each !== null);
        }
    },
    components: { MercenaryHeader, CommonPopupFrame, ContentsViewer, DateSelectorPopupVer2, MakeRequestJoinForm, CommonConfirmFrame, ProfileImage },
    data() {
        return {
            FORM_MODE: FORM_MODE,
            PROFILE_FOOT_WAY: PROFILE_FOOT_WAY,
            SOCCER_HOW_TYPE: SOCCER_HOW_TYPE,
            isShowMakeRequestJoinForm: false,
            TYPE: TYPE,
            imgSrcArr: [null, null, null],
            STEP_TWO_LABEL: STEP_TWO_LABEL,
            isShowDateSelector: false,
            isOpenCommonPopupFrame: false,
            popupTitle: '',
            name: '',
            birthday: '',
            team: '',
            selectedRegion: [],
            step: 1,
            regionList: [
                { region_name: '서울'},
                { region_name: '경기'},
                { region_name: '인천'},
                { region_name: '강원'},
                { region_name: '대전'},
                { region_name: '세종'},
                { region_name: '충남'},
                { region_name: '충북'},
                { region_name: '부산'},
                { region_name: '대구'},
                { region_name: '울산'},
                { region_name: '경남'},
                { region_name: '경북'},
                { region_name: '광주'},
                { region_name: '전남'},
                { region_name: '전북'},
                { region_name: '제주'},
            ],
            stepTwoArr: [
                {
                    label: STEP_TWO_LABEL.GRADE,
                    value: '',
                    placeholder: '학년',
                    popupTitle: '학년을 선택해주세요',
                },
                {
                    label: STEP_TWO_LABEL.FOOT_WAY,
                    value: '',
                    placeholder: '주발',
                    popupTitle: '주로 쓰는 발을 선택해주세요',
                },
                {
                    label: STEP_TWO_LABEL.HEIGHT,
                    value: '',
                    placeholder: '175'
                },
                {
                    label: STEP_TWO_LABEL.WEIGHT,
                    value: '',
                    placeholder: '67'
                },
                {
                    label: STEP_TWO_LABEL.POSITION,
                    value: '',
                    placeholder: 'FW',
                    popupTitle: '포지션을 선택해주세요',
                },
                {
                    label: STEP_TWO_LABEL.PREFERRED_AGE_TEAM,
                    value: '',
                    placeholder: '연령팀',
                    popupTitle: '희망하는 연령팀을 선택해 주세요',
                },
            ],
            selectList: [],
            gradeList: [
                { label: '초등학교 1학년', value: '초등학교 1학년' },
                { label: '초등학교 2학년', value: '초등학교 2학년' },
                { label: '초등학교 3학년', value: '초등학교 3학년' },
                { label: '초등학교 4학년', value: '초등학교 4학년' },
                { label: '초등학교 5학년', value: '초등학교 5학년' },
                { label: '초등학교 6학년', value: '초등학교 6학년' },
                { label: '중학교 1학년', value: '중학교 1학년' },
                { label: '중학교 2학년', value: '중학교 2학년' },
                { label: '중학교 3학년', value: '중학교 3학년' },
                { label: '고등학교 1학년', value: '고등학교 1학년' },
                { label: '고등학교 2학년', value: '고등학교 2학년' },
                { label: '고등학교 3학년', value: '고등학교 3학년' },
            ],
            footWayList: [
                { label: '왼발', value: '왼발' },
                { label: '오른발', value: '오른발' },
                { label: '양발', value: '양발' },
            ],
            positionList: [
                { label: 'FW(공격수)', value: 'FW' },
                { label: 'MF(미드필더)', value: 'MF' },
                { label: 'DF(수비수)', value: 'DF' },
                { label: 'GK(골키퍼)', value: 'GK' },
            ],
            preferredAgeTeamList: [
                { label: 'U12', value: 'U12' },
                { label: 'U15', value: 'U15' },
                { label: 'U18', value: 'U18' },
            ],
            selectPosition: '',
            introduceMaxLen: 20,
            isIntroduceComposing: false,
            introduceComposingValue: '',
            introduceText: '',
            requestText: '',
            youtubeLink: '',
            isShowYoutubeFrame: false,
            preparedFormData: {},
            playerProofFiles: [],
            curIndex: -1,
            playerProofFilesIndex: -1,
            playerProofFileNextId: 0,
            playerProofFileInputs: {},
            isShowConfirmPopup: false,
            soccerhowInfo: {},
            playerTypeCopy: '',
            isShowUpdateConfirmPopup: false,
            updateStep: 1
        }
    },
    methods: {
        normalizeText(value) {
            if (value === null || value === undefined) return ''
            return String(value)
        },
        limitIntroduceText(value) {
            const text = this.normalizeText(value)
            return text.length > this.introduceMaxLen ? text.slice(0, this.introduceMaxLen) : text
        },
        setIntroduceText(value) {
            this.introduceText = this.limitIntroduceText(value)
        },
        onIntroduceInput(e) {
            const value = e?.target?.value ?? ''
            if (this.isIntroduceComposing) {
                this.introduceComposingValue = this.limitIntroduceText(value)
                return
            }
            this.setIntroduceText(value)
            if (e?.target) e.target.value = this.introduceText
        },
        onIntroduceCompositionStart(e) {
            this.isIntroduceComposing = true
            this.introduceComposingValue = this.limitIntroduceText(e?.target?.value ?? '')
        },
        onIntroduceCompositionUpdate(e) {
            this.introduceComposingValue = this.limitIntroduceText(e?.target?.value ?? '')
        },
        onIntroduceCompositionEnd(e) {
            this.isIntroduceComposing = false
            this.setIntroduceText(e?.target?.value ?? '')
            this.introduceComposingValue = ''
            this.$nextTick(() => {
                if (e?.target) e.target.value = this.introduceText
            })
        },
        closeUpdateConfirmPopup() {
            this.isShowUpdateConfirmPopup = false
            this.updateStep = 1
        },
        async updateSoccerHow() {
            if (!this.imgSrcArr.some(each => each !== null)) {
                this.$GlobalStore.showAlert('최소 한 장의 미디어를 추가해주세요.')
                return
            }
            this.makeRequestForm()

        },
        async makeRequestForm() {
            let formData = null;
            formData = this.createFormDataForRequest(true)

            const res = await this.$Axios.post('/api/soccerhow/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            if (res.data.code === 0) {
                if (this.$GlobalStore.loginInfo().visit_reason === '축구선수 희망' || this.$GlobalStore.loginInfo().visit_reason === '축구 진로 상담' || this.$GlobalStore.loginInfo().visit_reason === '축구팀 입단') {
                    this.$Util.sendEventClick('축구팀입단_축구선수_희망_요청서작성', true)
                } else {
                    this.$Util.sendEventClick("축구팀입단_요청서작성", true)
                }
                this.isLoading = false
                if (res.data.code === 0) {
                    if (res.data.login_info) {
                        this.$GlobalStore.setLoginInfo(res.data.login_info)
                    }
                    this.completeAction()
                    this.completeModifyAction(this.introduceText, this.requestText)
                    this.$GlobalStore.closeLastModal()
                }
            }
        },
        async deleteDraft() {
            const res = await this.$Axios.post('/api/soccerhow/delete/draft')
            if (res.data.code === 0) {
                this.closeRequestJoinForm(true)
            }
        },
        async getSoccerhowInfo() {
            const res = await this.$Axios.get('/api/soccerhow/detail', { params: { soccerhow_idx: this.soccerhowIdx, mode: this.mode } })
            if (res.data.code === 0) {
                const soccerhow = res.data.soccerhow
                this.soccerhowInfo = soccerhow
                this.name = this.soccerhowInfo.additional_info_name
                this.playerTypeCopy = this.soccerhowInfo.additional_info_player_type
                this.birthday = this.soccerhowInfo.additional_info_birthday
                this.stepTwoArr[0].value = this.soccerhowInfo.additional_info_grade
                this.stepTwoArr[1].value = this.transFootWay(this.$GlobalStore.loginInfo().foot_way)
                this.stepTwoArr[2].value = this.$GlobalStore.loginInfo().height ? this.$GlobalStore.loginInfo().height : ''
                this.stepTwoArr[3].value = this.soccerhowInfo.additional_info_weight
                this.stepTwoArr[4].value = this.soccerhowInfo.additional_info_position
                this.stepTwoArr[5].value = this.soccerhowInfo.additional_info_preferred_age_team
                this.selectedRegion = this.soccerhowInfo.additional_info_region ? this.soccerhowInfo.additional_info_region.split(',') : []
                this.introduceText = this.soccerhowInfo.additional_info_introduce
                this.requestText = this.$Util.removeYoutubeLink(this.soccerhowInfo.contents)
                if (this.$Util.getYoutubeLinkArr(this.soccerhowInfo.contents)) {
                    this.youtubeLink = this.$Util.getYoutubeLinkArr(this.soccerhowInfo.contents)[0]
                }
                if (this.playerTypeCopy === TYPE.ELITE) {
                    this.team = this.soccerhowInfo.additional_info_affiliation_team
                    let index = 0;

                    for (let i = 1; i <= 5; i++) {
                        const path = this.soccerhowInfo[`additional_info_proof_image_path${i}`];
                    
                        if (path) {
                            this.checkIsVideo(path);
                            this.playerProofFiles[i - 1] = {
                                src: this.$resourcePath + path,
                                id: 'proof_file' + index,
                                path: path,
                                thumPath: path,
                                isFileTag: false,
                                isEnlarge: false,
                                large_width: 0,
                                large_height: 0,
                                default_width: 0,
                                default_height: 0
                            };
                            index++;
                        }
                    }
                }
                let index = 0;
                if (this.soccerhowInfo.media_path1) {
                    this.checkIsVideo(this.soccerhowInfo.media_path1)
                    this.imgSrcArr[0] = { src: this.$resourcePath + this.soccerhowInfo.thumbnail_path1, id: 'file' + index, path: this.soccerhowInfo.media_path1, thumPath: this.soccerhowInfo.thumbnail_path1, isFileTag: false, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                    index++;
                }
                if (this.soccerhowInfo.media_path2) {
                    this.checkIsVideo(this.soccerhowInfo.media_path2)
                    this.imgSrcArr[1] = { src: this.$resourcePath + this.soccerhowInfo.thumbnail_path2, id: 'file' + index, path: this.soccerhowInfo.media_path2, thumPath: this.soccerhowInfo.thumbnail_path2, isFileTag: false, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                    index++;
                }
                if (this.soccerhowInfo.media_path3) {
                    this.checkIsVideo(this.soccerhowInfo.media_path3)
                    this.imgSrcArr[2] = { src: this.$resourcePath + this.soccerhowInfo.thumbnail_path3, id: 'file' + index, path: this.soccerhowInfo.media_path3, thumPath: this.soccerhowInfo.thumbnail_path3, isFileTag: false, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                }

            }
        },
        transFootWay(footWay) {
            if (footWay == 0) {
                return '양발'
            } else if (footWay == 1) {
                return '왼발'
            } else if (footWay == 2) {
                return '오른발'
            } else {
                return ''
            }
        },
        setDraftInfo() {
            this.name = this.soccerhowDraft.name
            this.birthday = this.soccerhowDraft.birthday
            this.stepTwoArr[0].value = this.soccerhowDraft.grade
            this.stepTwoArr[1].value = this.transFootWay(this.soccerhowDraft.foot_way)
            this.stepTwoArr[2].value = this.soccerhowDraft.height
            this.stepTwoArr[3].value = this.soccerhowDraft.weight
            this.stepTwoArr[4].value = this.soccerhowDraft.position
            this.stepTwoArr[5].value = this.soccerhowDraft.preferred_age_team
            this.selectedRegion = this.soccerhowDraft.region ? this.soccerhowDraft.region.split(',') : []
            this.introduceText = this.soccerhowDraft.introduce
            this.requestText = this.$Util.removeYoutubeLink(this.soccerhowDraft.contents)
            if (this.soccerhowDraft.contents && this.$Util.getYoutubeLinkArr(this.soccerhowDraft.contents)) {
                this.youtubeLink = this.$Util.getYoutubeLinkArr(this.soccerhowDraft.contents)[0]
            }

            if (this.playerType === TYPE.ELITE) {
                this.team = this.soccerhowDraft.affiliation_team
                let index = 0;

                for (let i = 1; i <= 5; i++) {
                    const path = this.soccerhowDraft[`proof_image_path${i}`];
                
                    if (path) {
                        this.checkIsVideo(path);
                        this.playerProofFiles[i - 1] = {
                            src: this.$resourcePath + path,
                            id: 'proof_file' + index,
                            path: path,
                            thumPath: path,
                            isFileTag: false,
                            isEnlarge: false,
                            large_width: 0,
                            large_height: 0,
                            default_width: 0,
                            default_height: 0
                        };
                        index++;
                    }
                }

            }

            let index = 0;
            if (this.soccerhowDraft.media_path1) {
                this.checkIsVideo(this.soccerhowDraft.media_path1)
                this.imgSrcArr[0] = { src: this.$resourcePath + this.soccerhowDraft.thumbnail_path1, id: 'file' + index, path: this.soccerhowDraft.media_path1, thumPath: this.soccerhowDraft.thumbnail_path1, isFileTag: false, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                index++;
            }
            if (this.soccerhowDraft.media_path2) {
                this.checkIsVideo(this.soccerhowDraft.media_path2)
                this.imgSrcArr[1] = { src: this.$resourcePath + this.soccerhowDraft.thumbnail_path2, id: 'file' + index, path: this.soccerhowDraft.media_path2, thumPath: this.soccerhowDraft.thumbnail_path2, isFileTag: false, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                index++;
            }
            if (this.soccerhowDraft.media_path3) {
                this.checkIsVideo(this.soccerhowDraft.media_path3)
                this.imgSrcArr[2] = { src: this.$resourcePath + this.soccerhowDraft.thumbnail_path3, id: 'file' + index, path: this.soccerhowDraft.media_path3, thumPath: this.soccerhowDraft.thumbnail_path3, isFileTag: false, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
            }
        },
        setImgSrcArr() {
            let index = 0;
            if (this.soccerhowDraft.media_path1) {
                this.checkIsVideo(this.soccerhowDraft.media_path1)
                this.imgSrcArr[0] = { src: this.$resourcePath + this.soccerhowDraft.thumbnail_path1, id: 'file' + index, path: this.soccerhowDraft.media_path1, thumPath: this.soccerhowDraft.thumbnail_path1, isFileTag: false, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                index++;
            }
        },
        checkIsVideo(src) {
            const extension = src.split('.').pop().toLowerCase()
            if (extension === 'mp4' || extension === 'mov' || extension === 'qt') {
                return true
            } else {
                return false
            }
        },
        async saveSoccerHowDraft() {
            this.$GlobalStore.addModal('Loading', {
                transitionName: '',
                isModalBackTransparent: true,
            })
            const formData = new FormData();
            formData.append('is_draft', this.isDraft ? '1' : '0');
            formData.append('contents', this.requestText + this.youtubeLink);
            for (let i = 0; i < this.imgSrcArr.length; i++) {
                const curImgSrc = this.imgSrcArr[i]
                if (curImgSrc?.isFileTag && this.$refs[curImgSrc.id]?.files[0]) {
                    formData.append('file' + i, this.$refs[curImgSrc.id].files[0]);
                }
            }
            // 기본 정보 추가 정보
            formData.append('player_type', this.playerType);
            formData.append('name', this.name);
            formData.append('birthday', this.birthday.replaceAll(' ', '')); 
            if (this.playerType === TYPE.ELITE) {
                formData.append('affiliation_team', this.team);
            }
            if (this.playerType === TYPE.ELITE && this.playerProofFiles.length > 0) {
                for (let i = 0; i < this.playerProofFiles.length; i++) {
                    const fileData = this.playerProofFiles[i];
                    if (fileData?.isFileTag && this.playerProofFileInputs?.[fileData.id]) {
                        const input = this.playerProofFileInputs[fileData.id];
                        if (input.files?.[0]) {
                            formData.append('proof_file' + i, input.files[0]);
                        }
                    }
                }
            }
            formData.append('grade', this.stepTwoArr[0].value);
            formData.append('foot_way', this.setFootWay(this.stepTwoArr[1].value));
            formData.append('height', this.stepTwoArr[2].value);
            formData.append('weight', this.stepTwoArr[3].value);
            formData.append('position', this.stepTwoArr[4].value);
            formData.append('preferred_age_team', this.stepTwoArr[5].value);
            formData.append('region', this.selectedRegion.join(','));
            formData.append('introduce', this.introduceText);

            const res = await this.$Axios.post('/api/soccerhow/save/draft', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            if (res.data.code == 0) {
                this.$GlobalStore.closeLastModal()
                setTimeout(() => {
                    this.closeRequestJoinForm(true)
                }, 200);
            }
        },
        closeConfirmPopup() {
            this.isShowConfirmPopup = false
        },
        showConfirmPopup(step) {
            if (this.mode === FORM_MODE.UPDATE) {
                this.updateStep = step
                this.isShowUpdateConfirmPopup = true
            } else {
                this.isShowConfirmPopup = true
            }
        },
        deletePlayerProofFiles(i) {
            const file = this.playerProofFiles[i]
            const fileId = file?.id
            this.playerProofFiles.splice(i, 1)
            if (fileId && this.playerProofFileInputs[fileId]) {
                const input = this.playerProofFileInputs[fileId]
                input.value = ''
                input.removeEventListener('change', this.readPlayerProofFilesURL)
                if (input.parentNode) input.parentNode.removeChild(input)
                delete this.playerProofFileInputs[fileId]
            }
        },
        showPlayerProofFiles() {
            if (this.playerProofFiles.length >= 5) return
            const newId = this.playerProofFileNextId++
            const fileId = 'player_proof_file' + newId
            this.makePlayerProofFilesInput(fileId)
            const input = this.playerProofFileInputs[fileId]
            if (input) input.click()
        },
        makePlayerProofFilesInput(fileId) {
            if (this.playerProofFileInputs[fileId]) return
            const input = document.createElement('input')
            input.type = 'file'
            input.style.display = 'none'
            input.dataset.id = fileId
            input.addEventListener('change', (e) => this.readPlayerProofFilesURL(e))
            document.body.appendChild(input)
            this.playerProofFileInputs[fileId] = input
        },
        readPlayerProofFilesURL(e) {
            const input = e.currentTarget;

            if (input.files && input.files[0]) {
                var extension = input.files[0].name.split('.').pop().toLowerCase();

                if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp' || extension === 'mp4' || extension === 'mov' || extension === 'qt') {

                    var reader = new FileReader();
                    reader.onload = (e) => {
                        if (input.files[0].size > 1024 * 1024 * 1024) {
                            input.files[0].value = '';
                            this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.');
                            return;
                        }

                        const data = { src: e.target.result, isVideo: false, id: input.getAttribute('data-id'), isFileTag: true, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                        if (extension === 'mp4' || extension === 'mov' || extension === 'qt') data.isVideo = true
                        this.playerProofFiles.push(data)
                    }
                    reader.readAsDataURL(input.files[0]);
                } else {
                    this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp, mp4, mov, qt만 업로드 가능합니다.');
                }
            }
        },
        closeRequestJoinForm(isComplete) {
            if (isComplete) {
                this.$GlobalStore.closeModalAll()
                this.isShowMakeRequestJoinForm = false;
            } else {
                this.isShowMakeRequestJoinForm = false
            }
        },
        beforeClose() {
            if (this.step === 1) {
                this.$GlobalStore.closeLastModal()
            } else {
                this.step--
            }
        },
        showCalendar() {
            this.isShowDateSelector = true;
        },
        setBirthDate(date) {
            this.birthday = date.replaceAll('-', '. ');
        },
        detectLink() {
            const isYoutubeLinkComplete = this.$Util.checkYoutubeLink(this.youtubeLink);
            if (isYoutubeLinkComplete) {
                this.isShowYoutubeFrame = true;
            }
        },
        deleteImg(i) {
            const curImgSrc = this.imgSrcArr[i]
            if (curImgSrc?.id && this.$refs[curImgSrc.id]) {
                this.$refs[curImgSrc.id].value = ''
            }
            this.$set(this.imgSrcArr, i, null)
        },
        showFiles(index) {
            this.curIndex = index
            this.$refs['file' + index].click();
        },
        readURL(e) {
            const input = e.currentTarget;

            if (input.files && input.files[0]) {
                var extension = input.files[0].name.split('.').pop().toLowerCase();

                if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp' || extension === 'mp4' || extension === 'mov' || extension === 'qt') {

                    var reader = new FileReader();
                    reader.onload = (e) => {
                        if (input.files[0].size > 1024 * 1024 * 1024) {
                            input.files[0].value = '';
                            this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.');
                            return;
                        }

                        const data = { src: e.target.result, isVideo: false, id: input.getAttribute('data-id'), isFileTag: true, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                        if (extension === 'mp4' || extension === 'mov' || extension === 'qt') data.isVideo = true
                        // this.imgSrcArr = [...this.imgSrcArr, data];
                        this.$set(this.imgSrcArr, this.curIndex, data)
                    }
                    reader.readAsDataURL(input.files[0]);
                } else {
                    this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp, mp4, mov, qt만 업로드 가능합니다.');
                }
            }
        },
        resetRegion() {
            this.selectedRegion = []
        },
        selectRegion(region) {
            if (region === '전국') {
                if (this.selectedRegion.includes('전국')) {
                    this.selectedRegion = this.selectedRegion.filter(each => each !== '전국')
                } else {
                    this.selectedRegion = ['전국']
                }
            } else {
                if (this.selectedRegion.includes('전국')) {
                    this.selectedRegion = this.selectedRegion.filter(each => each !== '전국')
                }
                if (this.selectedRegion.includes(region)) {
                    this.selectedRegion = this.selectedRegion.filter(each => each !== region)
                } else {
                    this.selectedRegion.push(region)
                }
            }
        },
        nextStep() {
            if (this.step === 1) {
                this.inspectionStepOne()
            } else if (this.step === 2) {
                this.inspectionStepTwo()
            } else if (this.step === 3) {
                this.inspectionStepThree()
            } else if (this.step === 4) {
                console.log(this.introduceText)
                this.inspectionStepFour()
            } else if (this.step === 5) {
                this.inspectionStepFive()
            }

        },
        inspectionStepOne() {
            if (this.playerType === TYPE.ELITE || this.playerTypeCopy === TYPE.ELITE) {
                if (this.name === '' || this.name === null) {
                    this.$GlobalStore.showAlert('이름을 입력해주세요.')
                    return
                }
                if (this.birthday === '' || this.birthday === null) {
                    this.$GlobalStore.showAlert('생년월일을 입력해주세요.')
                    return
                }
                if (this.team === '' || this.team === null) {
                    this.$GlobalStore.showAlert('소속팀을 입력해주세요')
                    return
                }
                if (this.playerProofFiles.length === 0) {
                    this.$GlobalStore.showAlert('선수임을 증명할 수 있는 사진 또는 JoinKFA 등록 사진을 추가해주세요')
                    return
                }
            } else {
                if (this.name === '' || this.name === null) {
                    this.$GlobalStore.showAlert('이름을 입력해주세요.')
                    return
                }
                if (this.birthday === '' || this.birthday === null) {
                    this.$GlobalStore.showAlert('생년월일을 입력해주세요.')
                    return
                }
            }
            this.step++
        },
        inspectionStepTwo() {
            if (this.stepTwoArr[0].value === '' || this.stepTwoArr[0].value === null) {
                this.$GlobalStore.showAlert('학년을 선택해주세요.')
                return
            }
            if (this.stepTwoArr[1].value === '' || this.stepTwoArr[1].value === null) {
                this.$GlobalStore.showAlert('주발을 선택해주세요.')
                return
            }
            if (this.stepTwoArr[2].value === '' || this.stepTwoArr[2].value === null) {
                this.$GlobalStore.showAlert('키를 입력해주세요.')
                return
            }
            if (this.stepTwoArr[3].value === '' || this.stepTwoArr[3].value === null) {
                this.$GlobalStore.showAlert('몸무게를 입력해주세요.')
                return
            }
            if (this.stepTwoArr[4].value === '' || this.stepTwoArr[4].value === null) {
                this.$GlobalStore.showAlert('주 포지션을 선택해주세요.')
                return
            }
            if (this.stepTwoArr[5].value === '' || this.stepTwoArr[5].value === null) {
                this.$GlobalStore.showAlert('희망하는 연령팀을 선택해 주세요.')
                return
            }
            this.step++
        },
        inspectionStepThree() {
            if (this.selectedRegion.length === 0) {
                this.$GlobalStore.showAlert('희망하는 지역을 선택해주세요.')
                return
            }
            this.step++
        },
        inspectionStepFour() {
            if (this.introduceText === '') {
                this.$GlobalStore.showAlert('한 줄 소개를 입력해주세요.')
                return
            }
            if (this.requestText === '' || this.requestText === null) {
                this.$GlobalStore.showAlert('입단 요청서를 입력해주세요.')
                return
            }
            this.step++
        },
        inspectionStepFive() {
            if (!this.imgSrcArr.some(each => each !== null)) {
                this.$GlobalStore.showAlert('최소 한 장의 미디어를 추가해주세요.')
                return
            }
            this.step++
        },
        async uploadSoccerHow() {
            this.preparedFormData = this.createFormDataForRequest();
            this.isShowMakeRequestJoinForm = true;
            // const res = await this.$Axios.get('/api/member/family/exist')
            // if (res.data.is_family_exist) {
            //     this.preparedFormData = this.createFormDataForRequest();
            //     this.isShowMakeRequestJoinForm = true;
            // } else {
            //     const preparedFormData = this.createFormDataForRequest();
            //     this.$GlobalStore.addModal('ParentAuth', {
            //         selected_player_type: this.playerType,
            //         preparedFormData: preparedFormData,
            //         saveSoccerHowDraft: this.saveSoccerHowDraft,
            //     })
            // }
        },
        createFormDataForRequest(isUpdate = false) {
            const formData = new FormData();
            if (this.mode === FORM_MODE.UPDATE) {
                formData.append('soccerhowIdx', this.soccerhowIdx);
            }
            formData.append('topic', '')
            formData.append('entredPoint', 0)
            formData.append('isCheckedFastAnswer', '0')
            formData.append('title', '');
            formData.append('contents', this.requestText + this.youtubeLink);
            formData.append('type', SOCCER_HOW_TYPE.SC_JOIN);
            formData.append('mode', isUpdate ? 'update' : this.isDraft ? 'draft' : 'insert');
            formData.append('isYoutubeExist', (this.youtubeLink !== '' ? '1' : '0'));
            for (let i = 0; i < this.imgSrcArr.length; i++) {
                const curImgSrc = this.imgSrcArr[i]
                if (curImgSrc?.isFileTag && this.$refs[curImgSrc.id]?.files[0]) {
                    formData.append('file' + i, this.$refs[curImgSrc.id].files[0]);
                }
            }
            if (this.isDraft || isUpdate) {
                for (let i = 0; i < this.imgSrcArr.length; i++) {
                    if (this.imgSrcArr[i]) {
                        if (!this.imgSrcArr[i].isFileTag) {
                            formData.append('filePath' + i, this.imgSrcArr[i].path);
                            if (this.imgSrcArr[i].thumPath) formData.append('thumPath' + i, this.imgSrcArr[i].thumPath);
                        }
                    }
                }
                formData.append('writer_idx', this.$GlobalStore.loginInfo().idx);
            }
            // 기본 정보 추가 정보
            formData.append('player_type', this.mode === FORM_MODE.UPDATE ? this.playerTypeCopy : this.playerType);
            formData.append('is_additional_info', true)
            formData.append('name', this.name);
            formData.append('birthday', this.birthday.replaceAll(' ', '')); 
            if (this.playerType === TYPE.ELITE || this.playerTypeCopy === TYPE.ELITE) {
                formData.append('affiliation_team', this.team);
            }
            if ((this.playerType === TYPE.ELITE || this.playerTypeCopy === TYPE.ELITE) && this.playerProofFiles.length > 0) {
                for (let i = 0; i < this.playerProofFiles.length; i++) {
                    const fileData = this.playerProofFiles[i];
                    if (fileData?.isFileTag && this.playerProofFileInputs?.[fileData.id]) {
                        const input = this.playerProofFileInputs[fileData.id];
                        if (input.files?.[0]) {
                            formData.append('proof_file' + i, input.files[0]);
                        }
                    }
                }

                if (this.isDraft || this.mode === FORM_MODE.UPDATE) {
                    for (let i = 0; i < this.playerProofFiles.length; i++) {
                        const fileData = this.playerProofFiles[i];
                        if (!fileData?.isFileTag) {
                            formData.append('proof_image_path' + i, fileData.path);
                            formData.append('proof_image_thumb_path' + i, fileData.thumPath);
                        }
                    }
                }
            }
            formData.append('grade', this.stepTwoArr[0].value);
            formData.append('foot_way', this.setFootWay(this.stepTwoArr[1].value));
            formData.append('height', this.stepTwoArr[2].value);
            formData.append('weight', this.stepTwoArr[3].value);
            formData.append('position', this.stepTwoArr[4].value);
            formData.append('preferred_age_team', this.stepTwoArr[5].value);
            formData.append('region', this.selectedRegion.join(','));
            formData.append('introduce', this.introduceText);

            return formData;
        },
        setFootWay(footWay) {
            if (footWay === '왼발') {
                return PROFILE_FOOT_WAY.LEFT
            } else if (footWay === '오른발') {
                return PROFILE_FOOT_WAY.RIGHT
            } else {
                return PROFILE_FOOT_WAY.BOTH
            }
        },
        selectItem(item) {
            this.popupTitle = item.popupTitle
            switch (item.label) {
                case STEP_TWO_LABEL.GRADE:
                    this.selectList = this.gradeList
                    this.selectPosition = ''
                    this.isOpenCommonPopupFrame = true
                    break;
                case STEP_TWO_LABEL.FOOT_WAY:
                    this.selectList = this.footWayList
                    this.selectPosition = ''
                    this.isOpenCommonPopupFrame = true
                    break;
                case STEP_TWO_LABEL.POSITION:
                    this.selectList = this.positionList
                    this.selectPosition = STEP_TWO_LABEL.POSITION
                    this.isOpenCommonPopupFrame = true
                    break;
                case STEP_TWO_LABEL.PREFERRED_AGE_TEAM:
                    this.selectList = this.preferredAgeTeamList
                    this.selectPosition = STEP_TWO_LABEL.PREFERRED_AGE_TEAM
                    this.isOpenCommonPopupFrame = true
                    break;
                default:
                    this.isOpenCommonPopupFrame = false
                    break;
            }
        },
        closeCommonPopupFrame() {
            this.isOpenCommonPopupFrame = false
        },
        selectItemList(item) {
            let target = null

            if (this.selectPosition === '') {
                target = this.stepTwoArr.find(each => this.popupTitle === each.popupTitle)
            } else {
                target = this.stepTwoArr.find(each => each.label === this.selectPosition)
            }

            if (target) {
                target.value = item.value
            }

            this.isOpenCommonPopupFrame = false
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    font-weight: 500;
}

.status_bar_container {
    padding: 0 24px;
}

.content_container {
    padding: 0 24px;
    margin-top: 20px;
    flex: 1;
    overflow-y: scroll;
    padding-bottom: 20px;
}

.status_bar_content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.status_bar_content_title {
    font-size: 14px;
    line-height: 24px;
    color: var(--color-main);
}

.status_bar_step {
    font-weight: 700;
    font-size: 14px;
}

.status_bar_progress {
    height: 10px;
    border-radius: 12px;
    background-color: #f5f5f5;
    margin-top: 5px;
}

.status_bar_progress_bar {
    width: 20%;
    background-color: var(--color-main);
    border-radius: 12px;
    height: 100%;
}

.main_title {
    margin-top: 10px;
    font-size: 32px;
    line-height: 40px;
    font-weight: 900;
}

.form_wrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.form_wrapper .label {
    font-weight: 700;
    font-size: 12px;
    line-height: 24px;
}

.form_wrapper .common_input {
    height: 54px;
    border-radius: 12px;
    outline: none;
    border: 1px solid #d9d9d9;
    background: #210F030D;
    padding: 0 12px;
    font-size: 14px;
}

input::placeholder {
    font-size: 14px;
    color: #bdbdbd;
}

.content_container .form_wrapper:nth-child(2),
.content_container .form_wrapper:nth-child(3) {
    margin-top: 10px;
}

.description {
    font-weight: 700;
    font-size: 12px;
    line-height: 24px;
    color: #808080;
}

.image_container {
    margin-top: 15px;
    border-radius: 12px;
    border: 2px dashed #d9d9d9;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
}

.upload_image_box {
    position: relative;
    border-radius: 12px;
    border: 2px dashed #d9d9d9;
    height: 150px;
    width: 219px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
}

.upload_image_container {
    display: flex;
    overflow-x: scroll;
    margin: 0 -20px;
    padding: 0 20px;
    margin-top: 15px;
}

.image_container_text {
    font-weight: 700;
    font-size: 12px;
    line-height: 24px;
    color: #808080;
}

.footer_container {
    padding: 0 24px;
    margin-top: 10px;
}

.footer_description {
    display: flex;
    gap: 4px;
    align-items: center;
}

.exclamation_mark {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid #808080;
    flex-shrink: 0;
    font-size: 12px;
    font-weight: 700;
}

.footer_description_text {
    font-size: 14px;
    line-height: 18px;
    color: #808080;
}

.footer_btn {
    width: 100%;
    text-align: center;
    height: 48px;
    line-height: 48px;
    background-color: #ebebeb;
    color: #d9d9d9;
    font-weight: 700;
    border-radius: 12px;
    margin-bottom: 20px;
    margin-top: 12px;
}

.active {
    background-color: var(--color-main);
    color: #fff;
}

.select_container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px 18PX;
}

.select_wrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.select_wrapper .label {
    font-weight: 700;
    font-size: 12px;
    line-height: 24px;
}

.select_box {
    height: 54px;
    border-radius: 12px;
    background: #210F030D;
    border: 1px solid #d9d9d9;
    display: flex;
    align-items: center;
    padding-left: 12px;
}

.select_wrapper .common_input {
    width: 100%;
    height: 54px;
    border-radius: 12px;
    outline: none;
    border: 1px solid #d9d9d9;
    background: #210F030D;
    padding: 0 12px;
}

.select_wrapper .common_input::placeholder {
    color: #bbb;
    font-size: 16px;
    font-weight: 700;
}

.select_box_text {
    font-size: 16px;
    font-weight: 700;
    color: #bbb;
}

.common_popup_header {
    width: 36px;
    height: 5px;
    background-color: #d9d9d9;
    margin: 0 auto;
    border-radius: 5px;
    margin-top: 5px;
}

.common_popup_content {
    flex: 1;
    overflow-y: scroll;
    padding: 0 24px;
    padding-bottom: 10px;
}

.common_popup_content .title {
    margin-top: 30px;
    line-height: 20px;
    font-weight: 700;
    font-size: 20px;
    text-align: center;
}

.common_popup_content .select_list_wrapper {
    margin-top: 5px;
}

.common_popup_content .select_list_item {
    padding: 15px 0;
    border-bottom: 1px solid #210F0317;
    font-weight: 500;
    
}

.select_box_text.active {
    color: #210F03;
    background-color: transparent;
}

.step_three_description {
    font-weight: 500;
    line-height: 20px;
    color: #808080;
    margin-top: 4px;
    font-size: 14px;
}

.step_three_description span {
    font-weight: 700;
    color: var(--color-main);
}

.common_region_box {
    padding: 10px 0;
    line-height: 22px;
    color: #bcbcbc;
    border: 1px solid #d9d9d9;
    border-radius: 12px;
    text-align: center;
}

.common_region_box.all_region {
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    margin-top: 25px;
    margin-bottom: 20px;
}

.all_region_text {
    line-height: 22px;
}

.region_list_title {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #808080;
    margin-bottom: 9px;
}

.region_list_container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px 12px;
}

.region_reset_btn {
    margin-top: 25px;
    font-size: 12px;
    color: #808080;
    text-align: center;
    text-decoration: underline;
    line-height: 24px;
}

.active_region {
    border: 1px solid var(--color-main);
    color: var(--color-main);
    background: #FFF6EA;
}

.skill_container {
    margin-top: 20px;
}

.introduce_container {
    margin-bottom: 40px;
}

.introduce_title_wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}

.skill_title {
    font-weight: 700;
    line-height: 20px;
}

.introduce_count {
    line-height: 20px;
}

.introduce_count span {
    font-weight: 700;
    color: var(--color-main);
}

.skill_common_input {
    border-radius: 12px;
    outline: none;
    background: #210F030D;
    padding: 15px 12px;
    border: none;
    width: 100%;
}

.skill_common_input::placeholder {
    font-size: 14px;
    color: #bbb;
}

.skill_common_input.textarea {
    height: 250px;
    margin-top: 20px;
    line-height: 24px;
    padding: 12px;
}

.skill_common_input.textarea::placeholder {
    font-size: 14px;
    color: #bbb;
    line-height: 24px ;
}

.request_description {
    font-size: 14px;
    color: #808080;
    line-height: 18px;
    text-align: center;
}

.confirm_draft_content {
    position: relative;
    /* min-width: 280px; */
    padding-top: 20px;
}

.confirm_close_btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: 0px 1px 9.1px 0px #00000014;
    cursor: pointer;
}

.confirm_icon_wrapper {
    width: 40px;
    height: 40px;
    margin: 0 auto 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #FF71111A;
}

.confirm_title {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    margin-bottom: 5px;
}

.confirm_desc {
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #808080;
    margin-bottom: 30px;
}

.confirm_btn_row {
    display: flex;
    gap: 12px;
}

.confirm_btn_new {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    border: 1px solid #210F03;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    flex-basis: 35%;
}

.confirm_btn_continue {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background-color: var(--color-main);
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    flex-basis: 65%;
}

/* 상단 헤더 섹션 */
.header_section {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
}

.profile_section {
    display: flex;
    gap: 12px;
    flex: 1;
    align-items: flex-start;
}

.profile-image {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}

.profile_info {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.name_row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.player_name {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 700;
    line-height: 24px;
    color: #000;
}

.tags {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
}

.tag {
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    white-space: nowrap;
}

.elite_tag {
    background-color: var(--color-main);
    border: 1px solid #FF711180;
}

.not_elite_tag {
    background-color: #c7c7c7;
}

.verified_tag {
    background: #82FFAD33;
    border: 1px solid #82FFAD;
    display: flex;
    color: #159941;
    align-items: center;
    gap: 4px;
}

.not_verified_tag {
    background: #C8C8C84D;
    border: 1px solid #c8c8c8;
    display: flex;
    align-items: center;
    gap: 4px;
    color: #989898;
}

.location {
    font-size: 12px;
    line-height: 16px;
    color: #808080;
}

.age_badge {
    background: linear-gradient(360deg, #210F03 0%, #6A6A6A 100%);
    color: #fff;
    padding: 4px 8px;
    border-radius: 8px;
    font-weight: 900;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* 중앙 스탯 섹션 */
.stats_section {
    background: #FF71111A;
    border-radius: 12px;
    padding: 14px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 10px;
}

.stat_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    flex: 1;
}

.stat_label {
    font-size: 12px;
    color: #FF9800;
    font-weight: 400;
}

.stat_value {
    font-weight: 700;
    color: #000;
    margin-top: 7px;
}

.stat_divider {
    width: 1px;
    height: 30px;
    background-color: #FFE0B2;
}

/* 하단 소개 섹션 */
.intro_section {
    display: flex;
    flex-direction: column;
    gap: 11px;
}

.quote {
    font-weight: 700;
    color: #000;
    line-height: 24px;
}

.intro_text_wrapper {
    position: relative;
    max-height: 96px;
    overflow: hidden;
}

.intro_text {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #333;
}

.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical
}

.region_section {
    display: flex;
    gap: 5px;
    align-items: center;
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.region_common_wrapper {
    font-size: 12px;
    font-weight: 500;
    line-height: 24px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    border-radius: 14px;
    height: 24px;
    flex-shrink: 0;
}
</style>